export const getEIDReportByEID =
  (eid: string | null) =>
  (state: State): EIDReport | undefined =>
    eid ? state.eidReport.byId[eid] : undefined;
